import FallbackComponent from '@components/std-components/FallbackComponent'
import React, { FC, lazy, Suspense } from 'react'
import { IEhancedAddProductViewContainer } from './EhancedAddProductViewContainer'

const EhancedAddProductViewContainerLazy: FC<IEhancedAddProductViewContainer> = lazy(
  () => import('./EhancedAddProductViewContainer')
)

const EhancedAddProductViewContainer: FC<IEhancedAddProductViewContainer> = props => {
  return (
    <Suspense fallback={FallbackComponent}>
      <EhancedAddProductViewContainerLazy {...props} />
    </Suspense>
  )
}

export default EhancedAddProductViewContainer
